import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable, WritableSignal, computed, signal } from '@angular/core';
import { SCREEN_SIZES, TScreenSize } from '../models/screen.model';

@Injectable({
  providedIn: 'root'
})
export class ScreenService {
  public size: WritableSignal<TScreenSize> = signal('xs');
  public isHandset: WritableSignal<boolean> = signal(false);
  public isTablet: WritableSignal<boolean> = signal(false);
  public isWeb: WritableSignal<boolean> = signal(false);
  public isMobile = computed(() => this.isHandset() || this.isTablet());

  constructor(
    private breakpointObserver: BreakpointObserver,
  ) {
    this.breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium,
      Breakpoints.Large,
      Breakpoints.XLarge,
    ]).subscribe(result => {
      if (result.breakpoints[Breakpoints.XSmall]) {
        this.size.set('xs');
      }
      if (result.breakpoints[Breakpoints.Small]) {
        this.size.set('sm');
      }
      if (result.breakpoints[Breakpoints.Medium]) {
        this.size.set('md');
      }
      if (result.breakpoints[Breakpoints.Large]) {
        this.size.set('lg');
      }
      if (result.breakpoints[Breakpoints.XLarge]) {
        this.size.set('xl');
      }
    });

    this.breakpointObserver.observe([
      Breakpoints.Handset,
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe(state => {
      this.isHandset.set(state.matches);
    });

    this.breakpointObserver.observe([
      Breakpoints.Tablet,
      Breakpoints.TabletLandscape,
      Breakpoints.TabletPortrait
    ]).subscribe(state => {
      this.isTablet.set(state.matches);
    });

    this.breakpointObserver.observe([
      Breakpoints.Web,
      Breakpoints.WebLandscape,
      Breakpoints.WebPortrait
    ]).subscribe(state => {
      this.isWeb.set(state.matches);
    });
  }

  lowerThen(size: TScreenSize) {
    return SCREEN_SIZES.indexOf(this.size()) < SCREEN_SIZES.indexOf(size);
  }

  greaterThen(size: TScreenSize) {
    return SCREEN_SIZES.indexOf(this.size()) > SCREEN_SIZES.indexOf(size);
  }
}
